































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Vuedraggable from "vuedraggable";
import { uploadFile } from "@/utils/api";


@Component({
  components:{
    Vuedraggable
  }
})
export default class UploadImg extends Vue {
  @Prop(String) specItemImageUrl!: string;
  @Watch('specItemImageUrl',{immediate:true,deep:true})
  onPersonChanged(val: string){
    if(val && val!=''){
      this.imgShow=true;
      this.imageUrl=val;
    }
  }
  imgShow: boolean = false;//是否上传图片
  imageUrl: string = '';//上传图片地址
  action: string = process.env.NODE_ENV === 'development' ? `/bff-supplier/supplier/file/uploadFile` : `${location.origin}/api/bff-supplier/supplier/file/uploadFile`;//上传地址
  uploadHeaders: object = {} //上传请求头
  mounted() {
    let authToken = localStorage.getItem('authToken')
    if (authToken) {
      this.uploadHeaders["Authorization"] = `Bearer ${authToken}`;
    }
  }


  handleAvatarSuccess(res, file) {
    this.$emit("update:specItemImageUrl",res.fileUrl);
    this.$emit('upDateTable');
  }
  /* 上传前验证 */
  beforeAvatarUpload(file) {
    const isJPG = file.type === 'image/jpeg' ||  file.type === 'image/png';
    const isLt2M = file.size/1024/1024 < 1;
    if (!isJPG) {
      this.$message.error('请上传格式为PNG、JPG、JPEG的图片!');
    }
    if (!isLt2M) {
      this.$message.error('请上传大小不超过1M的图片!');
    }
    return isJPG && isLt2M;
  }
    
  
}
